import * as React from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ArchiveIcon from "@mui/icons-material/Archive";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {TaskDto} from "../../../../types/task";

// -----------------------------
// Row actions menu
// -----------------------------
export interface RowMenuState {
  anchorEl: HTMLElement | null;
  row: TaskDto | null
}

export default function RowActionsMenu({state, onClose}: { state: RowMenuState; onClose: (action?: string) => void }) {
  const open = Boolean(state.anchorEl);
  return (
    <Menu
      anchorEl={state.anchorEl}
      open={open}
      onClose={() => onClose()}
      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      transformOrigin={{vertical: "top", horizontal: "right"}}
    >
      <MenuItem onClick={() => onClose("report")}><AssessmentIcon fontSize="small"
                                                                  style={{marginRight: 8}}/> Report</MenuItem>
      <MenuItem onClick={() => onClose("edit")}><InfoOutlinedIcon fontSize="small"
                                                                  style={{marginRight: 8}}/> Edit</MenuItem>
      <MenuItem onClick={() => onClose("suspend")}><ArchiveIcon fontSize="small"
                                                                style={{marginRight: 8}}/> Suspend</MenuItem>
      <MenuItem onClick={() => onClose("suspend")}><ArchiveIcon fontSize="small"
                                                                style={{marginRight: 8}}/> Resume</MenuItem>

      <Divider component="li" sx={{my: 0.5}}/>
      <MenuItem onClick={() => onClose("delete")} sx={{color: "error.main"}}><ArchiveIcon fontSize="small"
                                                                                          style={{marginRight: 8}}/> Delete</MenuItem>


    </Menu>
  );
}
